export const PRODUCT_TABS = [
  {
    autobotID: 'DASH_TAB_HOTELS',
    name: 'HOTELS',
    id: 'hotels',
    query: { tab: 'hotels' }
  },
  {
    autobotID: 'DASH_TAB_FLIGHTS',
    name: 'FLIGHTS',
    id: 'flights',
    query: { tab: 'flights' }
  },
  {
    autobotID: 'DASH_TAB_HOTEL + FLIGHT',
    name: 'BUNDLE + SAVE',
    id: 'vacations',
    query: { tab: 'vacations' }
  },
  {
    autobotID: 'DASH_TAB_CARS',
    name: 'CARS',
    id: 'cars',
    query: { tab: 'cars' }
  },
  {
    autobotID: 'DASH_TAB_CRUISES',
    name: 'CRUISES',
    id: 'cruises',
    query: { tab: 'cruises' }
  }
] as const

export const HEADERS = {
  hotels: {
    headline: 'Save more on your next hotel',
    subheadline: 'Use code FREEDOM20 to save $20 on Express Deals'
  },
  flights: {
    headline: 'Save more on your next flight',
    subheadline: 'Thousands of deals made every day'
  },
  vacations: {
    headline: 'Save up to $625 on your hotel and flight',
    subheadline: 'Book together for our best deals'
  },
  cars: {
    headline: 'Save more on your next rental car',
    subheadline: 'Thousands of deals made every day'
  },
  cruises: {
    headline: 'Save more on your next cruise',
    subheadline: 'Thousands of deals made every day'
  }
}

export const AMENITIES = {
  AIRSHUTTL: 'Search Hotels with Airport Shuttles',
  CASINO: 'Search Hotels with Casinos',
  FBRKFST: 'Search Hotels with Free Breakfast',
  FINTRNT: 'Search Hotels with Free Internet',
  FITSPA: 'Search Hotels with Gyms',
  FPRKING: 'Search Hotels with Free Parking',
  INCLUSIVE: 'Search All Inclusive Hotels',
  KITCHEN: 'Search Hotels with Kitchens',
  PETALLOW: 'Search Pet Friendly Hotels',
  SPOOL: 'Search Hotels with Swimming Pools',
  RESTRNT: 'Search Hotels with Restaurants',
  SPA: 'Search Hotels with Spas',
  CHEAP: {
    DEFAULT: '',
    CHEAP_HOTELS: 'Search Cheap Hotels',
    DISCOUNTED_HOTELS: 'Search Discounted Hotels',
    POPULAR_FOR_LESS: 'Search Popular Hotels for Less'
  }
} as const
